import React from 'react';

export const Group: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className='border-b border-gray-200 p-5'>{children}</div>
);
